import React, { useState } from 'react';
import './ContactPage.css';

const CONTACT_FORM_NAME = 'contact';
const CONTACT_EMAIL = process.env.REACT_APP_PRESS_CONTACT_EMAIL || 'd-byron@live.com';

const getErrorMessage = (error) => {
  if (typeof error === 'string') {
    return error;
  }

  if (error?.message) {
    return error.message;
  }

  if (typeof error?.status === 'number') {
    return `Request failed with status ${error.status}.`;
  }

  return 'Unable to send your message right now. Please try again or email D Byron directly.';
};

function ContactPage() {
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const sendMessage = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: 'sending', message: 'Sending...' });

    try {
      const form = e.currentTarget;
      const formData = new FormData(form);
      formData.set('form-name', CONTACT_FORM_NAME);
      formData.set('to_email', CONTACT_EMAIL);

      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData).toString(),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}.`);
      }

      setStatus({
        type: 'success',
        message: 'Message sent successfully. D Byron will get back to you soon.',
      });
      form.reset();
    } catch (error) {
      console.error('Contact form error:', error);
      setStatus({ type: 'error', message: getErrorMessage(error) });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <h1>Contact D Byron</h1>
      <form
        name={CONTACT_FORM_NAME}
        method="POST"
        data-netlify="true"
        netlify-honeypot="bot-field"
        onSubmit={sendMessage}
      >
        <input type="hidden" name="form-name" value={CONTACT_FORM_NAME} />
        <input type="hidden" name="to_email" value={CONTACT_EMAIL} />
        <p hidden>
          <label htmlFor="bot-field">
            Do not fill this out: <input id="bot-field" name="bot-field" />
          </label>
        </p>
        <div>
          <label htmlFor="user_name">Name:</label>
          <input
            type="text"
            id="user_name"
            name="user_name"
            required
            placeholder="Your Name"
          />
        </div>
        <div>
          <label htmlFor="user_email">Your Email:</label>
          <input
            type="email"
            id="user_email"
            name="user_email"
            required
            placeholder="your.email@example.com"
          />
        </div>
        <div>
          <label htmlFor="message">Message:</label>
          <textarea
            id="message"
            name="message"
            required
            placeholder="Your message to D Byron"
            rows="5"
          ></textarea>
        </div>
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Sending...' : 'Send Message'}
        </button>
      </form>
      {status.message && (
        <p className={`status-message ${status.type}`} aria-live="polite">
          {status.message}
        </p>
      )}
      <div className="contact-info">
        <p>Your message will be sent through the site form.</p>
        <p>
          Prefer email? Reach D Byron directly at{' '}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
        </p>
      </div>
    </div>
  );
}

export default ContactPage;
